import ImagesMainBannerChristmas2024NewAppleWhiteSvg from '@/public/images/main-banner/christmas_2024/new/appleWhite.svg';
import ImagesMainBannerChristmas2024NewBottlesOfTheMonthWebp from '@/public/images/main-banner/christmas_2024/new/bottles_of_the_month.webp';
import ImagesMainBannerChristmas2024NewBuyOrSellWhiskyAndSpiritsWebp from '@/public/images/main-banner/christmas_2024/new/buy_or_sell_whisky_and_spirits.webp';
import ImagesMainBannerChristmas2024NewDownloadTheAppWebp from '@/public/images/main-banner/christmas_2024/new/download_the_app.webp';
import ImagesMainBannerChristmas2024NewGooglePlaySvg from '@/public/images/main-banner/christmas_2024/new/googlePlay.svg';
import ImagesMainBannerChristmas2024NewSellFasterThanEverWebp from '@/public/images/main-banner/christmas_2024/new/sell_faster_than_ever.webp';
import ImagesMainBannerChristmas2024NewSpecialDealsWebp from '@/public/images/main-banner/christmas_2024/new/special_deals.webp';

export {
  ImagesMainBannerChristmas2024NewAppleWhiteSvg,
  ImagesMainBannerChristmas2024NewBottlesOfTheMonthWebp,
  ImagesMainBannerChristmas2024NewBuyOrSellWhiskyAndSpiritsWebp,
  ImagesMainBannerChristmas2024NewDownloadTheAppWebp,
  ImagesMainBannerChristmas2024NewGooglePlaySvg,
  ImagesMainBannerChristmas2024NewSellFasterThanEverWebp,
  ImagesMainBannerChristmas2024NewSpecialDealsWebp,
};
